import React from 'react';
import OptionButton from '../shared/OptionButton';
import { RunningCommunity } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RunningCommunityStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <OptionButton label="Run Club" value={RunningCommunity.RUN_CLUB} selected={answer === RunningCommunity.RUN_CLUB} onClick={onAnswer} />
      <OptionButton label="Parkrun" value={RunningCommunity.PARK_RUN} selected={answer === RunningCommunity.PARK_RUN} onClick={onAnswer} />
      <OptionButton label="No" value={RunningCommunity.NONE} selected={answer === RunningCommunity.NONE} onClick={onAnswer} />
    </div>
  );
};

export default RunningCommunityStep;
